import MatomoAnalyticsProvider from './matomo-provider';
import { INamespaceDefinition } from './analytics-provider';

export enum Environment {
  DEV,
  ALPHA,
  PROD,
}

const MATOMO_ENDPOINTS = {
  INTERNAL: {
    [Environment.DEV]: 'https://matomo.dev.bloomberg.com/matomo.php',
    [Environment.ALPHA]: 'https://matomo.alpha.bloomberg.com/matomo.php',
    [Environment.PROD]: 'https://matomo.prod.bloomberg.com/matomo.php',
  },
  EXTERNAL: {
    [Environment.DEV]: 'https://logs.dev.bloomberg.com/interactions',
    [Environment.ALPHA]: 'https://logs.alpha.bloomberg.com/interactions',
    [Environment.PROD]: 'https://logs.bloomberg.com/interactions',
  },
};

function trackerUrlFromEnvironment(
  environment: Environment,
  internal: boolean
): string {
  if (internal) {
    return MATOMO_ENDPOINTS.INTERNAL[environment];
  } else {
    return MATOMO_ENDPOINTS.EXTERNAL[environment];
  }
}

export default class BloombergAnalyticsProvider extends MatomoAnalyticsProvider {
  constructor(
    siteId: number,
    environment: Environment,
    internal = false,
    namespaceDefinition: INamespaceDefinition = {} as INamespaceDefinition
  ) {
    super(
      siteId,
      trackerUrlFromEnvironment(environment, internal),
      namespaceDefinition
    );
  }
}
